// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-mx-offset[data-v-60fa8da5]{width:calc(100% + 32px);margin-left:-16px}@media (min-width: 768px){.-mx-offset[data-v-60fa8da5]{width:auto;margin:0}.min-w-more-button[data-v-60fa8da5]{min-width:240px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
